import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CommonService } from '../../../../services/common/common.service';
import { TermsDataService, TermsColumnsService, ApplicationsDataService} from '../../../services';
import { Term, TermsResult, ApplicationsResult } from '../../../interfaces';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
@Component({
  selector: 'app-post-form',
  templateUrl: './term-form.component.html',
  styleUrls: ['./term-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class TermFormComponent implements OnInit {

  public term: Term = {};
  public termForm: FormGroup = new FormGroup({});
  public terms: Term[] = [];
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public applications:any;
  selectedFile: File | null;

  public Editor = ClassicEditor;
  applicationValue: any;
  formData = new FormData();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private messageService: MessageService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private termsDataService: TermsDataService,
    public termsColumnsService: TermsColumnsService,
    public editorService: EditorService,
    public applicationsDataService: ApplicationsDataService,

  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null
  }

  ngOnInit(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.term = this.dynamicDialogConfig.data.post;
    }
  if (typeof this.term.id === 'undefined' || this.term.id === null) {
      this.term.id = null;
  }
    this.getapplications();
    this.getTerms();
    this.prepareFrom();
    
  }


  getapplications(){
    this.applicationsDataService.getApplications().subscribe((response: ApplicationsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.applications = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }

  getTerms(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.posts !== 'undefined' && this.dynamicDialogConfig.data.posts.length > 0) {
      this.terms = this.dynamicDialogConfig.data.posts;
      return;
    }
    this.termsDataService.getTerms().subscribe((response: TermsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.terms = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.termForm = new FormGroup({
      id: new FormControl(this.term.id, []),
      content: new FormControl(this.term.content, []),
      application: new FormControl(this.applicationValue, [Validators.required, ]),

     
    });
  }

  onChange(e:any) {
    this.applicationValue = e.value;
  }

  list() {
    this.router.navigate(['/posts']);
  }

  showErrors() {
      const invalidFields: string[] = [];
      Object.keys(this.termForm.controls).forEach((field: any) => {
        const control = this.termForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.termForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    console.log(this.applicationValue.id)
    this.term = this.termForm.value;
    this.disableSubmit = true;
    this.formData.append('content', this.termForm ? this.termForm.value.content : null);
    this.formData.append('application', this.applicationValue.id);

    if (this.term.id === null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  update(redirect: boolean) {
    this.termsDataService.updateTerm(this.formData, this.termForm.value.id).subscribe((data: any) => {
      this.disableSubmit = false;
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      console.warn(error);
    });
  }

  add(redirect: boolean) {
    console.log(this.applicationValue.id)
    console.log(this.formData)

    this.termsDataService.addTerm(this.formData).subscribe((data: any) => {
        this.disableSubmit = false;
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        console.warn(error);
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('imagePath', this.selectedFile);
    }
  }

}

@Component({
  selector: 'app-post-form',
  templateUrl: './term-form.component.html',
  styleUrls: ['./term-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogTermFormComponent extends TermFormComponent {
}

